import { Navigate } from "react-router-dom";
import AccessDenied from "../pages/accessDenied/AccessDenied";
import { ROLE } from "../features/auth/AuthSlice";
import { useLocation } from "react-router";
import { useAppSelector } from "../app/hooks";
import {
  selectCurrentUser,
  selectIsAuthenticated,
} from "../features/auth/AuthSlice";

interface Props {
  component: React.ComponentType | any;
  path?: string;
  roles: Array<ROLE>;
}

const PrivateRoute: React.FC<Props> = ({
  component: RouteComponent,
  roles,
}) => {
  const location = useLocation();
  const user = useAppSelector(selectCurrentUser);
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const userHasRequiredRole = user && roles.includes(user.role) ? true : false;

  // Must be isAuthenticated change later, deploy purposes
  if (isAuthenticated && userHasRequiredRole) {
    return <RouteComponent />;
  }

  if (isAuthenticated && !userHasRequiredRole) {
    return <AccessDenied />;
  }

  return <Navigate to="/login" replace state={{ from: location }} />;
};

export default PrivateRoute;
